<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form-model :model="model" :rules="validatorRules" @keyup.enter.native="submitForm" ref="form" slot="detail">
        <a-row>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="名称" prop="name">
              <a-input placeholder="请输入流程名称" v-model="model.name" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="图标" prop="icon">
              <a-input placeholder="点击选择图标" v-model="model.icon">
                <a-icon @click="selectIcons" slot="addonAfter" type="setting" />
              </a-input>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="分类" prop="classifyId">
              <a-select allowClear placeholder="请选择流程分类" v-model="model.classifyId">
                <a-select-option :key="item.id" :value="item.id" v-for="item in classifyListData">{{item.name}}</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="模版" prop="tpls">
              <a-select allowClear mode="multiple" placeholder="请选择模版" v-model="model.tpls">
                <a-select-option :key="item.id" :value="item.id" v-for="item in templates">{{item.name}}</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="通知">
              <a-select allowClear placeholder="请选择流程通知" v-model="model.notice">
                <a-select-option :value="1">邮件</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="任务">
              <a-select allowClear placeholder="请选择流程任务" v-model="model.task">
                <a-select-option
                  :key="index"
                  :value="item.full_name"
                  v-for="(item, index) in taskListData"
                >{{item.name}}</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="24">
            <a-form-model-item
              :labelCol="{xs: { span: 24 },sm: { span: 2 }}"
              :wrapperCol="{xs: { span: 24 },sm: { span: 22 }}"
              label="描述"
              prop="remarks"
            >
              <a-textarea :auto-size="{ minRows: 2, maxRows: 4}" placeholder="请输入流程描述" v-model="model.remarks" />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="24">
            <a-form-model-item
              :labelCol="{xs: { span: 24 },sm: { span: 2 }}"
              :wrapperCol="{xs: { span: 24 },sm: { span: 22 }}"
              label="流程"
              prop="structure"
            >
              <div style="border-radius: 4px; overflow:hidden">
                <div>
                  <WfdDesign
                    :data="model.structure"
                    :departments="departments"
                    :height="600"
                    :lang="lang"
                    :roles="roles"
                    :tasks="taskListData"
                    :templates="model.tpls"
                    :templates-base="templates"
                    :users="users"
                    ref="wfd"
                    v-if="wfdDesignRefresh"
                  />
                </div>
              </div>
            </a-form-model-item>
          </a-col>
        </a-row>
        <!-- 选择图标 -->
        <icons :iconChooseVisible="iconChooseVisible" @choose="handleIconChoose" @close="handleIconCancel"></icons>
      </a-form-model>
    </j-form-container>
  </a-spin>
</template>

<script>
  import { httpAction, getAction } from '@/api/manage'
  import { validateDuplicateValue } from '@/utils/util'
  import { getUserList } from '@/api/api'
  import Icons from '@/views/system/modules/icon/Icons'
  import WfdDesign from '@/components/wfd/components/Wfd'

  export default {
    name: 'PProcessInfoForm',
    components: { Icons, WfdDesign },
    props: {
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 4 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 20 },
        },
        confirmLoading: false,
        validatorRules: {
          name: [
            { required: true, message: '请输入流程名称!', trigger: 'blur' }
          ],
          icon: [
            { required: true, message: '请输入流程图标!', trigger: 'blur' }
          ],
          classifyId: [
            { required: true, message: '请选择流程分类!', trigger: ['blur', 'change'] }
          ],
          tpls: [
            { required: true, message: '请选择模版!', trigger: ['blur', 'change'] }
          ],
          structure: [
            { required: true, message: '请设计流程!', trigger: 'blur' }
          ],
          remarks: [
            { required: true, message: '请输入流程描述!', trigger: 'blur' }
          ]
        },
        url: {
          add: "/workorder/pProcessInfo/add",
          edit: "/workorder/pProcessInfo/edit",
          queryById: "/workorder/pProcessInfo/queryById",
          classifyList: "/workorder/pProcessClassify/queryList", //get
          templateList: "/workorder/pTplInfo/queryList", //get
          getOrdinaryDeptList: "/sys/sysDepart/listAllByTenantId" //get
        },
        classifyListData: [],
        templates: [],
        users: [],
        departments: [],
        taskListData: [],
        roles: [],
        iconChooseVisible: false,
        wfdDesignRefresh: true,
        lang: 'zh',
      }
    },
    computed: {
      formDisabled () {
        return this.disabled
      },
    },
    created () {
      //备份model原始值
      this.modelDefault = JSON.parse(JSON.stringify(this.model));
    },
    methods: {
      // 获取流程分类列表
      getClassifyList () {
        getAction(this.url.classifyList).then(response => {
          if (response.success) {
            this.classifyListData = response.result
          }
        })
      },
      // 获取模版列表
      getTemplates () {
        getAction(this.url.templateList).then(response => {
          if (response.success) {
            this.templates = response.result
          }
        })
      },
      // 获取用户
      getUsers () {
        getUserList({
          current: 1,
          pageSize: 99999
        }).then(response => {
          if (response.success) {
            this.users = response.result.records;
          }
        })
      },
      getRoles () {
        getAction('/sys/role/queryall').then(res => {
          this.roles = res.result
        })

      },
      // 获取部门
      getDepartments () {
        getAction(this.url.getOrdinaryDeptList).then(response => {
          if (response.success) {
            this.departments = response.result
          }
        })
      },
      add () {
        this.modelDefault = {
          id: undefined,
          name: '',
          tpls: [],
          structure: { 'edges': [], 'nodes': [], 'groups': [] },
          classifyId: '',
          tasks: [],
          notice: [1],
          icon: '',
          remarks: ''
        }
        this.edit(this.modelDefault);
      },
      edit (record) {
        this.getProcessInitData()
        this.wfdDesignRefresh = false
        this.$nextTick(() => {
          this.wfdDesignRefresh = true
        })
        this.model = Object.assign({}, record);
        this.visible = true;
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {

            const structureValue = this.$refs.wfd.graph.save()
            const r = this.verifyProcess(structureValue)
            if (r !== '') {
              this.$message.error(r)
              return
            }
            if (structureValue.nodes.length > 0 && structureValue.edges.length > 0) {
              //this.ruleForm.structure = structureValue  
              // 
              this.model.structure = structureValue
            } else {
              this.$message.error('没有流程数据，请完善流程')
              return
            }
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if (!this.model.id) {
              httpurl += this.url.add;
              method = 'post';
            } else {
              httpurl += this.url.edit;
              method = 'put';
            }
            httpAction(httpurl, this.model, method).then((res) => {
              if (res.success) {
                that.$message.success(res.message);
                that.$emit('ok');
              } else {
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }

        })
      },
      verifyProcess (structureValue) {
        for (var r of structureValue.nodes) {
          if (r.sort === undefined || r.sort === null || r.sort === '') {
            return '流程节点顺序不能为空'
          } else if (r.label === undefined || r.label === null || r.label === '') {
            return '流程节点标题不能为空'
          }
          if (r.clazz === 'userTask' || r.clazz === 'receiveTask') {
            if (r.assignType === undefined || r.assignType === null || r.assignType === '') {
              return '审批节点或处理节点的处理人类型不能为空'
            } else if (r.assignValue === undefined || r.assignValue === null || r.assignValue === '' || r.assignValue.length === 0) {
              return '审批节点或处理节点的处理人不能为空'
            }
          }
        }
        for (var e of structureValue.edges) {
          if (e.sort === undefined || e.sort === null || e.sort === '') {
            return '流转顺序不能为空'
          } else if (e.label === undefined || e.label === null || e.label === '') {
            return '流转标题不能为空'
          } else if (e.flowProperties === undefined || e.flowProperties === null || e.flowProperties === '') {
            return '流转属性不能为空'
          }
        }
        return ''
      },
      getProcessInitData () {
        this.getClassifyList()
        this.getTemplates()
        this.getUsers()
        this.getRoles()
        this.getDepartments()
      },
      selectIcons () {
        this.iconChooseVisible = true
      },
      handleIconCancel () {
        this.iconChooseVisible = false
      },
      handleIconChoose (value) {
        this.model.icon = value
        this.iconChooseVisible = false
      },
      queryProcessById (id) {

        getAction(this.url.queryById, { id }).then(res => {

        })
      }
    }
  }
</script>